import { NamedError } from "../../../utils/Errors"

export class AuthError extends NamedError<AuthErrors> {}

export enum AuthErrors {
    UnableToAuthenticate = "UnableToAuthenticate",
    UnableToFetchToken = "UnableToFetchToken"
}

/**
 * This function checks whether the given error is an auth related error.
 * 
 * Special case - Though we throw an AuthError in ProdAuthenticationProvider.GetAccessToken, this gets caught 
 * in GraphClientInitOptions. The graph error callback that we call there then remaps that 
 * AuthError into some other generic exception that has an error code of AuthErrors.UnableToFetchToken. 
 * So we need to check error.code below directly as well
 * @param error The error instance to use for evaluating whether this is an auth error
 */
export function IsAuthError(error: any) {
    return (error instanceof AuthError && (error.name == AuthErrors.UnableToAuthenticate || error.name == AuthErrors.UnableToFetchToken)
        || error.code == AuthErrors.UnableToFetchToken);
}
